import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenderPipe } from './gender.pipe';
import { SearchFilterPipe } from './search-filter.pipe';
import { SortByPipe } from './sort-by.pipe';
import { AgePipe } from './age.pipe';
import { DateDirective } from './date.directive';
import { CurrencyFormatterDirective } from './currency-formatter.directive';
import { TimePipe } from './time.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GenderPipe,
    SearchFilterPipe,
    SortByPipe,
    AgePipe,
    DateDirective,
    CurrencyFormatterDirective,
    TimePipe,
  ],
  exports: [
    GenderPipe,
    AgePipe,
    DateDirective,
    CurrencyFormatterDirective,
    TimePipe,
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipes.module.ts